const re = /[^a-z\s.\-']/gi;

export default re;
